const videoRoot = '/3dAssets/videos/';
export const VideoString = 
{
    LOBBYLOOP: videoRoot + "Lobby_Loop.mp4",//"Lobby_Loop.mp4",
    LOOBYTOINFO: videoRoot+'ToInfoBooth.mp4',
    LOOBYTODBR: videoRoot+'ToDBR.mp4',
    DBRLOOP: videoRoot+'dbr.mp4',

    LOBBYTOAudi: videoRoot + 'ToAuditorium.mp4',
    LOOBYTOPRODUCTSTALL: videoRoot +'ToProductStall.mp4',
    LOBBYTOBREAKOUT: videoRoot + 'breakout.mp4',
    BREAKOUTLOOP: videoRoot+'breakoutLoop.mp4',
    AUDITORIUM: videoRoot + 'Auditorium.mp4',
}